import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { UmbracoService } from "./umbraco.service";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ContentService {

  private _content: Subject<Map<string, string>> = new Subject();
  public content: Observable<Map<string, string>> = this._content.asObservable();

  constructor(
    private umbracoService: UmbracoService,
    private http: HttpClient) {

  }

  loadContent(documentTypeAlias: string, parentName: string, propertyAliasList: string[]) {
    this.umbracoService.postUmbracoDataWithParent(documentTypeAlias, parentName, propertyAliasList, '/content/getcontent')
      .pipe(
        map(
          (contentElements: any[]) => {

            let values = new Map<string, string>();
            contentElements.forEach(
              (contentElement: any) => {
                values.set(contentElement.label, contentElement.text);
              }
            )
            return values;
          }
        )
      )
      .subscribe(
        {
          next: (response: Map<string, string>) => {
            this._content.next(response);
          },
          error: (err: HttpErrorResponse) => {
            console.log(err);
          }  
        }
      );
  }


}



